import { getSiteUrl } from '@awpmarine/core/environment';

const siteUrl = getSiteUrl({ defaultValue: 'https://www.awpmarine.co.uk' });

export const config = {
  siteUrl,
  name: 'AWP Marine',
  domain: 'awpmarine.co.uk',
  themeColor: 'oklch(0.4864 0.1193 254.79)', // '#2a60a1',
  title: 'AWP Marine',
  description: 'Marine consultancy providing vessel inspections and surveys.',
};

// AWP Marine started trading in 2010; experience is derived so it never goes stale.
export const foundedYear = 2010;
export const experienceYears = new Date().getFullYear() - foundedYear;

// Headline figures. `inspections` is a rounded running total (update periodically). `ports` and
// `countries` come from the dashboard's legacy port data (~1,592 UN/LOCODE ports across 157
// countries), rounded down so the trailing "+" stays honest.
export const stats = {
  inspections: 20_000,
  ports: 1_500,
  countries: 150,
} as const;

// Mirrors the dedicated senders in @awpmarine/core/email-workflows; each has a logo in src/images/clients.
export const clients = ['Shell', 'BP', 'Chevron', 'ExxonMobil', 'ADNOC', 'Equinor', 'RightShip'] as const;
